import { render } from "./NotFound.vue?vue&type=template&id=22d76c69&scoped=true"
import script from "./NotFound.vue?vue&type=script&lang=js"
export * from "./NotFound.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-22d76c69"

export default script